export const maxValueRule = maxValue => ({
  max: maxValue,
  message: `Certifique-se de que este campo não tenha mais de ${maxValue} caracteres.`
});


export const formatCPF = (value) => {

  return value
    .replace(/\D/g, '') 
    .replace(/(\d{3})(\d)/, '$1.$2') 
    .replace(/(\d{3})(\d)/, '$1.$2') 
    .replace(/(\d{3})(\d{1,2})/, '$1-$2') 
    .replace(/(-\d{2})\d+?$/, '$1'); 
};
